import styled from "styled-components"
import { memo, useMemo } from "react"
import { IconCheck, IconCheckComplete } from "../icons/FirstSteps/IconCheck"

interface ProgressBarProps {
  totalSteps: number
  completedSteps: number
}

const ProgressBarContainer = styled.div<{ bgsize: string }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 4px;
  width: 100%;
  border-radius: 50px;
  border: 8px solid ${(props) => props.theme.palette.primary_alt_clear};
  background: linear-gradient(
    251.11deg,
    ${(props) => props.theme.palette.primary_alt_dark} 29.56%,
    ${(props) => props.theme.palette.primary_dark} 77.48%
  );
  background-size: ${(props) => props.bgsize};
  background-repeat: no-repeat;
  transition: all 0.5s ease-in-out;
`

const IconWrapper = styled.div<{ left: number }>`
  position: absolute;
  top: 50%;
  left: ${({ left }) => `calc(${left}% - 7px)`};
  transform: translate(-50%, -50%);
`

const ProgressBar = (props: ProgressBarProps) => {
  const { totalSteps, completedSteps } = props

  const backgroundSize = useMemo<string>(() => {
    const hasSteps = totalSteps > 0
    const percentage = hasSteps ? (completedSteps / totalSteps) * 100 : 0

    return `calc(${percentage}% - 7px) 100%`
  }, [totalSteps, completedSteps])

  const icons = useMemo<JSX.Element[]>(() => {
    return Array.from({ length: totalSteps }, (_, index) => {
      const leftPercentage = ((index + 1) / totalSteps) * 100
      const isComplete = index < completedSteps
      const IconComponent = isComplete ? IconCheckComplete : IconCheck

      return (
        <IconWrapper key={index} left={leftPercentage}>
          <IconComponent />
        </IconWrapper>
      )
    })
  }, [totalSteps, completedSteps])

  return <ProgressBarContainer bgsize={backgroundSize}>{icons}</ProgressBarContainer>
}

export default memo(ProgressBar)
